import React from "react";
import App from "@al/next/app";
import { withApp } from "@al/next/al-ex";
import { WebpImage } from "@al/akui-mobile";

import createGlobalConfig from "~/global/index";
import InitProgress from "~/components/ui/InitProgress";
import { initTracker } from "~/common/tracker";

if (process.browser) {
  initTracker();
}

/**
 * 2种方式定义_app
 * 1. 拓展，通过import App from '@al/next/app'继承
 * 2. 自定义Component
 * **/

class MyApp extends App {
  constructor(props) {
    super(props);
    WebpImage.initWebpOptions({
      req: props.ctx.req,
    });
    if (!props.ctx.err && !props.pageProps.statusCode) {
      // 渲染错误页时不处理
      const { ctx, globalUserInfo } = props.pageProps;
      if (!ctx.lifecycleStatus.isExport) {
        // 特别注意，prerender 时的中间态，是否登录不确定。需延迟至 csr 请求接口确认
        if (globalUserInfo && globalUserInfo.value && globalUserInfo.value.success) {
          ctx.store.dispatch(ctx.actions.sign.updateSignState(globalUserInfo.value.data));
        } else {
          ctx.store.dispatch(ctx.actions.sign.clearSignState());
        }
      }
    }
  }

  render() {
    const { Component, pageProps } = this.props;
    return (
      <React.Fragment>
        <InitProgress />
        <Component {...pageProps} />
      </React.Fragment>
    );
  }
}

export default withApp(MyApp, createGlobalConfig);
